import { Component, Input, AfterContentInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { generalSettings } from "../../../../main/settings";
import { Location } from "@angular/common";

@Component({
  selector: "edm-back-button",
  templateUrl: "./back-button.component.html",
  styleUrls: ["./back-button.component.scss"],
  standalone: false,
})
export class BackButtonComponent implements AfterContentInit {
  @Input() backUrl: string;
  @Input() position: string;
  @Input() displayStyle: string = "";

  isWatchingFromApp: boolean = false;

  backToTimeline: boolean = false;
  backToSearch: boolean = false;
  backToMyList: boolean = false;
  backToExplore: boolean = false;
  backToProduct: boolean = false;

  parentId: string;
  isSdui: boolean = false;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
  ) {
    this.setBackUrl();
  }

  ngAfterContentInit(): void {
    this.setBackUrl();
  }

  private setBackUrl(): void {
    if (this.backUrl === undefined) {
      this.isWatchingFromApp = this.router.url.includes("/assistir");
      this.route.queryParams
        .subscribe(
          (params: any): void => {
            const explorerParam = params['explorer'] === 'true' || this.router.url.includes('explorer=true');

            if (params['from'] == 'sdui' || params['sduiUrl'] || this.router.url.includes("comunidade")) {
              this.isSdui = true;
              this.backToExplore = explorerParam;
              return
            }

            this.backToTimeline = params['from'] !== null && params['from'] !== undefined && params['from'] == 'timeline';
            this.backToSearch = params['from'] !== null && params['from'] !== undefined && params['from'] == 'busca';
            this.backToMyList = params['from'] !== null && params['from'] !== undefined && params['from'] == 'minha-lista';
            this.backToExplore = explorerParam;
          },
          (): void => { }
        );
      this.route.params.subscribe(
        (params: string[]): void => {
          if (
            params["from"] == "sdui" ||
            params["sduiUrl"] ||
            this.router.url.includes("comunidade")
          ) {
            this.isSdui = true;
            return;
          }

          this.route.params.subscribe(
            (params: string[]): void => {
              this.parentId = params["productId"];
            },
            (): void => {},
          );

          this.backToTimeline =
            params["from"] !== null &&
            params["from"] !== undefined &&
            params["from"] == "timeline";
          this.backToSearch =
            params["from"] !== null &&
            params["from"] !== undefined &&
            params["from"] == "busca";
          this.backToMyList =
            params["from"] !== null &&
            params["from"] !== undefined &&
            params["from"] == "minha-lista";
          this.backToProduct =
            params["from"] !== null &&
            params["from"] !== undefined &&
            params["from"] == "produto";

          if (this.backToSearch && params["q"]) {
            this.backUrl = `/buscar?q=${params["q"]}`;
          }

          if (this.backToSearch) {
            if (!this.backUrl) {
              this.backUrl = "/buscar";
            }
          } else if (this.backToMyList) {
            this.backUrl = "/perfil/minha-lista";
          } else if (this.backToProduct) {
            this.backUrl = `/produtos/${this.parentId}`;
            if (params["q"]) {
              this.backUrl += `?from=busca&q=${params["q"]}`;
            }
          } else if (this.router.url.includes("/pdf")) {
            this.backUrl = this.router.url.replace("/pdf", "");
          } else {
            this.backUrl = "/produtos";
            this.backUrl += this.backToTimeline ? "" : "/" + this.parentId;
          }
        },
        (): void => {},
      );
      const anchor = sessionStorage.getItem('exploreLastAnchor');

      if (this.backToSearch) {
        this.backUrl = '/buscar';
      } else if (this.backToMyList) {
        this.backUrl = '/perfil/minha-lista';
      } else if (this.router.url.includes('/pdf')) {
        this.backUrl = this.router.url.replace('/pdf', '');
      } else if (this.backToExplore) {
        const params = anchor
          ? `?explorer=true&anchor=${encodeURIComponent(anchor)}`
          : '?explorer=true';
        this.backUrl = `/explorar${params}`;
      } else {
        this.backUrl = '/produtos';
        this.backUrl += this.backToTimeline ? '' : ('/' + this.parentId);
      }
    }
  }

  iconCustomLayoutClass(): string {
    return (
      generalSettings.timelineIconsLayout +
      "-icon" +
      " " +
      this.iconTypeLayoutClass() +
      (this.position !== null && this.position !== undefined
        ? " " + this.position
        : "") +
      " " +
      this.displayStyle
    );
  }

  iconTypeLayoutClass(): string {
    return generalSettings.iconsType + "-icons-type";
  }

  backUrlClick() {
    this.router.navigateByUrl(this.backUrl);
  }

  back(): void {
    const rawStack = sessionStorage.getItem("navigationStack");
    let stack: string[] = rawStack ? JSON.parse(rawStack) : [];

    const currentUrl = this.router.url;
    const currentPath = this.getPathWithSduiUrl(currentUrl);

    let lastDifferentIndex = stack.length - 1;
    while (
      lastDifferentIndex >= 0 &&
      this.getPathWithSduiUrl(stack[lastDifferentIndex]) === currentPath
    ) {
      lastDifferentIndex--;
    }

    stack = stack.slice(0, lastDifferentIndex + 1);

    const previous = stack[stack.length - 1];
    sessionStorage.setItem("navigationStack", JSON.stringify(stack));

    if (
      currentUrl.includes("support") ||
      currentUrl.includes("notifications")
    ) {
      this.router.navigateByUrl("/perfil");
      return;
    }

    if (currentUrl.includes("delete-history")) {
      this.router.navigateByUrl("/comunidade");
      return;
    }

    if (currentUrl.includes("search-results")) {
      this.router.navigateByUrl("/comunidade/pesquisa");
      return;
    }

    if (previous) {
      this.router.navigateByUrl(previous);
    } else if (this.backToExplore) {
      const anchor = sessionStorage.getItem('exploreLastAnchor');
      const params = anchor
        ? `?explorer=true&anchor=${encodeURIComponent(anchor)}`
        : '?explorer=true';
      this.router.navigateByUrl(`/explorar${params}`);
    } else if (this.backUrl) {
      this.router.navigateByUrl(this.backUrl);
    } else {
      this.router.navigate(['/']); // fallback
    }
  }

  private getPathWithSduiUrl(url: string): string {
    const SDUI_URL_NORMALIZATION: Record<string, string[]> = {
      "/user/history": ["date"],
      // adicione outros aqui que vc queira ignorar ou normalizar para o backbutton
    };

    const [base, query = ""] = url.split("?");
    const params = new URLSearchParams(query);
    const sduiUrl = params.get("sduiUrl");

    let normalizedSduiUrl = sduiUrl || "";
    if (normalizedSduiUrl) {
      const [pathOnly, sduiQuery = ""] = normalizedSduiUrl.split("?");
      const sduiParams = new URLSearchParams(sduiQuery);

      const ignoreParams = SDUI_URL_NORMALIZATION[pathOnly];
      if (ignoreParams?.length) {
        ignoreParams.forEach((key) => sduiParams.delete(key));
      }

      const cleanQuery = sduiParams.toString();
      normalizedSduiUrl = cleanQuery ? `${pathOnly}?${cleanQuery}` : pathOnly;
    }

    return `${base}__${normalizedSduiUrl}`;
  }
}
